// extracted by mini-css-extract-plugin
module.exports = {"table":"DeclarationFormPaymentTerm__table--2EkdQ m-table-list","currency":"DeclarationFormPaymentTerm__currency--1aqdI","cellBlank":"DeclarationFormPaymentTerm__cellBlank--3DeUJ"};